import { connect } from 'react-redux';

import { getUserFullNameWithMiddleName } from 'modules/user/utils/user';
import AccountDetailsHint from './AccountDetailsHint';

const mapStateToProps = (state) => {
  const { profile } = state.auth.userInfo;

  return {
    userEmail: profile.email,
    userFullName: getUserFullNameWithMiddleName(profile),
  };
};

export default connect(
  mapStateToProps,
)(AccountDetailsHint);
